<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    塘坑站<br>
站点介绍<br>
塘坑站呈东西走向位于龙岗大道与平盐铁路交叉口西南角，东北侧天河百货、沃尔码、麟恒广场，西北侧平盐铁路、安信大厦，西南侧横岗街道办、六联医院、天虹商场，东南侧华润万家。塘坑站以白色为主色调，柱体采用白色搪瓷钢板，在标准化、简约化的装修中赋予了车站浓厚的文化气息。塘坑站为半地下车站，站台位于地下，站厅位于地面。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:01	23:22	3号线	2分15-20秒	4分30秒<br>
双龙	06:02	23:50	3号线	2分15-20秒	4分30秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:03	23:22	3号线	3分15秒	5分钟<br>
双龙	06:05	23:50	3号线	3分15秒	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:03	00:22	3号线	3分15秒	5分钟<br>
双龙	06:05	00:50	3号线	3分15秒	5分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
六和路、六约派出所、深圳宝兴医院、永兴汽车站、六约邮政支局、华润万家（在出入口信息牌那里没有标注）<br><br>
B出入口:<br>
塘坑路、怡豪花园、岭南工业园、深圳市携创高级技工学校、塘坑大厦、塘坑小学<br><br>
C出入口:<br>
龙岗大道（在出入口信息牌那里没有标注）、康乐路、信义湛宝大厦、横岗街道办、八达工业村、平盐铁路桥，横岗天虹（在出入口信息牌那里没有标注）<br><br>
D出入口:<br>
龙岗大道（在出入口信息牌那里没有标注）、六约学校、麟恒中心广场（在出入口信息牌那里没有标注）、沃尔玛（在出入口信息牌那里没有标注）、六约社区健康服务中心<br><br>
公交换乘信息<br><br>
C出入口:<br>
公交站名： 塘坑地铁站<br>
M295,M266,M359,M239,M570,351,M190,366,357,M208，M309,M421，M380,M547,M563,深惠3A，深惠3线D出入口<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>